import { render, staticRenderFns } from "./AddRoomModal.vue?vue&type=template&id=46030b29"
import script from "./AddRoomModal.vue?vue&type=script&lang=js"
export * from "./AddRoomModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports